import React, { useContext, useState } from 'react';

import { RICOS_ANCHOR_TYPE, RICOS_LINK_TYPE } from './../../ricos-content';
import { EditorContext, ModalServiceContext, ToolbarContext } from './../../ricos-context';
import { getIsModalOpen, useModalState } from './../../ricos-modals/modal-service-provider';
import type { IToolbarItem } from './../../ricos-types';
import { LINK_MODAL_ID } from './../../_shared/link-modal/constants';
import { toggleLinkModal } from './../../_shared/link-modal/toggle-link-modal';
import { ToolbarButton } from './../../toolbars-ui';

export const EditLinkButton = ({ toolbarItem }: { toolbarItem: IToolbarItem }) => {
  const { getPublicCommands } = useContext(EditorContext);
  const { isMobile, t } = useContext(ToolbarContext);
  const modalService = useContext(ModalServiceContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(LINK_MODAL_ID));
  const [referenceElement, setReferenceElement] = useState<HTMLButtonElement | null>(null);
  const publicCommands = getPublicCommands();

  const openModal = () => {
    toggleLinkModal({
      initialValue: publicCommands.getLinkDataInSelection(),
      modalService,
      onSave: link => {
        publicCommands.insertDecoration(link.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE, link);
      },
      onUnlink: link => {
        publicCommands.deleteDecoration(link.anchor ? RICOS_ANCHOR_TYPE : RICOS_LINK_TYPE);
      },
      referenceElement,
    });
  };

  return (
    <ToolbarButton
      ref={setReferenceElement}
      isMobile={isMobile}
      active={isModalOpen || toolbarItem.attributes.active}
      tooltip={t(toolbarItem.presentation?.tooltip)}
      onClick={openModal}
      Icon={toolbarItem.presentation?.icon}
      dataHook={toolbarItem.presentation?.dataHook}
    />
  );
};
